// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import './Create.scss';
import SubmitButton from '../../Util/SubmitButton/SubmitButton';
import Request from '../../../api/Request';
import { Redirect } from 'react-router-dom';

@inject('messageStore')
@observer class Create extends Component<any, any> {

	@observable questionName: string = '';
	@observable firstQuestionOption: string = '';
	@observable secondQuestionOption: string = '';

	@observable loading: boolean = false;
	@observable created: boolean = false;
	
	maxLengthOptions: number = 20;
	maxLengthName: number = 100;

	id: number = 0;

	constructor(props: any) {
		super(props);

		this.create = this.create.bind(this);
		this.onChangeFirstQuestionOption = this.onChangeFirstQuestionOption.bind(this);
		this.onChangeSecondQuestionOption = this.onChangeSecondQuestionOption.bind(this);
		this.onChangeQuestionName = this.onChangeQuestionName.bind(this);
	}

	create(e: any) {
		e.preventDefault();

		if(this.questionName !== '' && this.firstQuestionOption !== '' && this.secondQuestionOption !== '') {
			this.loading = true;
			Request.post('/questions', {
				name: this.questionName,
				'questionOption[0][name]': this.firstQuestionOption,
				'questionOption[1][name]': this.secondQuestionOption
			}, {}).then((response) => {
				if (!response.status) {
					this.props.messageStore.setMessage('success', 'successfully created a new question', 2000);
					this.id = response.id;
					this.created = true;
				} 
				this.loading = false;
			})
		} else {
			if(this.questionName === '') {
				this.props.messageStore.setMessage('error', 'the name of the question cannot be blank');
			} else if(this.firstQuestionOption === '') {
				this.props.messageStore.setMessage('error', 'the first question option cannot be blank');
			} else {
				this.props.messageStore.setMessage('error', 'the second question option cannot be blank');
			}
		}
	}

	onChangeFirstQuestionOption(e: any): void {
		if (e.target.value.length < this.maxLengthOptions) {
			this.firstQuestionOption = e.target.value;
		}
	}

	onChangeSecondQuestionOption(e: any): void {
		if (e.target.value.length < this.maxLengthOptions) {
			this.secondQuestionOption = e.target.value;
		}
	}

	onChangeQuestionName(e: any): void {
		if (e.target.value.length < this.maxLengthName) {
			this.questionName = e.target.value;
		}
	}
	render() {
		if(this.created) {
			return (<Redirect to={"/question/" + this.id} />)	
		} else {
			return (
				<div className="question-create-form-wrapper">
					<h2>create question.</h2>
					<form autoComplete="off" onSubmit={this.create}>
						<label>
							<span>question:</span>
							<input type="text" name="username" value={this.questionName} onChange={this.onChangeQuestionName}/>
						</label>
						<div className="question-options">
							<label>
							<span>option #1:</span>
								<input type="text" name="username" value={this.firstQuestionOption} onChange={this.onChangeFirstQuestionOption}/>
							</label>
							<div className="vs">VS</div>
							<label>
							<span>option #2:</span>
								<input type="text" name="username" value={this.secondQuestionOption} onChange={this.onChangeSecondQuestionOption}/>
							</label>
						</div>
						<SubmitButton text="create" loading={this.loading}></SubmitButton>
					</form>
				</div>
			)
		}
	}
}

export default Create;